import { h, Component } from 'preact';
import Store from 'store/store';
import { loadScript } from 'utils/utils';
import s from 'components/bolt/nativeVideo/nativeVideo.sss';

export default class NativeVideo extends Component {
	constructor(props) {
		super(props);

		this.progressTracking = {};

		this.videoName = this.props.activeVideo.videoSrc.split('\\').pop().split('/').pop();

		this.videoPlaying = this.videoPlaying.bind(this);
		this.videoPaused = this.videoPaused.bind(this);
		this.progressTracker = this.progressTracker.bind(this);
		this.videoCanPlayHandler = this.videoCanPlayHandler.bind(this);
	}

	play() {
		this.$video?.play();
	}
	get duration() {
		return this.$video?.duration || 0;
	}

	componentDidMount() {
		const { autoplay, onEnded, activeVideo } = this.props;

		if (activeVideo.videoSrc.match(/m3u8$/)) {
			if (typeof Hls === 'undefined') {
				loadScript('https://cdn.jsdelivr.net/npm/hls.js@latest')
					.then(() => this.initHLS(activeVideo.videoSrc, autoplay));
			} else {
				this.initHLS(activeVideo.videoSrc, autoplay);
			}
		}
		if (this.$video) {
			if (autoplay) {
				this.$video.load();
				this.$video.play();
			}
			if (onEnded) {
				this.$video.addEventListener('ended', onEnded);
			}
			if (this.props.fromStart) {
				this.$video.currentTime = 0;
			}

			this.$video.addEventListener('canplay', this.videoCanPlayHandler);
			this.$video.addEventListener('playing', this.videoPlaying);
			this.$video.addEventListener('pause', this.videoPaused);

			// Video already loaded, have to call the callback manually
			if (this.$video.readyState) {
				this.videoCanPlayHandler();
			}
		}
	}

	componentWillUnmount() {
		this.$video.removeEventListener('ended', this.props.onEnded);
		this.$video.removeEventListener('canplay', this.videoCanPlayHandler);
		this.$video.removeEventListener('playing', this.videoPlaying);
		this.$video.removeEventListener('pause', this.videoPaused);
		cancelAnimationFrame(this.timer);
	}

	initHLS(src, autoplay) {
		if (typeof Hls !== 'undefined' && window.Hls.isSupported()) {
			const hls = new window.Hls();
			hls.loadSource(src);
			hls.attachMedia(this.$video);
			if (autoplay) {
				this.$video.play();
			}
		}
	}

	videoCanPlayHandler() {
		if (this.videoCanPlay) {
			return;
		}

		this.videoCanPlay = true;
		this.setState({
			playing: !this.$video.paused,
			loading: false
		});

		if (typeof this.props.canPlayCallback === 'function') {
			this.props.canPlayCallback(this.$video);
		}
	}

	progressTracker() {
		if (!this.trackProgress || !this.$video) {
			// We shouldn't be tracking the progress, so let's quit
			return;
		}

		// Only update the state progress if displaying the controls
		// if (this.props.showControls) {
		// 	this.setState({ progress: this.$video.currentTime });
		// }

		const progress = this.$video.currentTime / this.$video.duration;

		let step = [0, 25, 50, 75, 95].find(step => progress > (step / 100) && !this.progressTracking[step]);

		if (step || step === 0) {
			this.progressTracking[step] = true;
			Store.emit('VIDEO_PLAYER_PROGRESS', {
				step,
				video: this.videoName,
				time: this.$video.currentTime,
				platform: 'native',
				isShowtimesMessage: this.props.isShowtimesMessage,
				isTrailerOverlay: this.props.isTrailerOverlay,
				isTrailer: this.props.isTrailer
			});
		}

		this.timer = requestAnimationFrame(this.progressTracker);
	}

	videoPlaying() {
		if (this.props.useTracking && !this.progressTracking[0]) {
			Store.emit('VIDEO_PLAYER_PROGRESS', {
				step: 0,
				video: this.videoName,
				time: this.$video.currentTime,
				platform: 'native',
				isShowtimesMessage: this.props.isShowtimesMessage,
				isTrailerOverlay: this.props.isTrailerOverlay,
				isTrailer: this.props.isTrailer
			});
			this.progressTracking[0] = true;
		}

		let state = this.state;
		let newState = {
			playing:  true,
			loading:  false,
			duration: this.$video.duration,
			muted:    this.$video.muted
		};
		let actualNewState = Object.keys(newState).reduce((o, k) => {
			let val = newState[k];
			if (state[k] !== val) {
				o[k] = newState[k];
			}
			return o;
		}, {});
		if (Object.keys(actualNewState).length) {
			this.setState(actualNewState);
		}

		if (!this.trackProgress && this.props.useTracking) {
			this.trackProgress = true;
			// Start tracking the progress
			cancelAnimationFrame(this.timer);
			this.timer = requestAnimationFrame(this.progressTracker);
		}
	}

	videoPaused() {
		cancelAnimationFrame(this.timer);
		this.trackProgress = false;

		this.setState({
			playing: false,
			loading: false
		});
	}

	render(props) {
		const { activeVideo, overrideStyles, muted } = props;
		const captionsLabel = activeVideo.captionsSrc && activeVideo.captionsSrc.replace(/.*\/([^/]*)\.[^/]+$/, '$1');
		const videoFile = activeVideo.videoSrc;

		return (
			<video
				ref={$ref => this.$video = $ref}
				webkit-playsinline playsinline
				controls
				poster={activeVideo.posterSrc || activeVideo.thumbSrc}
				aria-label={activeVideo.ariaLabel}
				class={overrideStyles && s.nativeVideo}
				muted={muted}
				key={videoFile}
			>
				{videoFile.includes('.webm') && <source src={videoFile} type="video/webm" />}
				<source src={videoFile.replace(/\.[^.]*$/, '.mp4')} type="video/mp4" />
				{activeVideo.captionsSrc && (
					<track
						label={captionsLabel}
						src={activeVideo.captionsSrc}
						kind="captions"
						srclang={activeVideo.captionsLang}
						default
					/>
				)}
			</video>
		);
	}
}
